declare global {
  interface Window {
    fbq: any
    _fbq: any
    __fbPixelInitialized?: boolean
    __fbPixelEvents?: Record<string, boolean>
  }
}

const PIXEL_ID = '1443042830884093'

/**
 * Initialize Meta Pixel - safe to call multiple times, only runs once.
 * Uses window flag to survive hot reloads and React StrictMode.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.__fbPixelInitialized) return

  // Facebook Pixel base code
  if (!window.fbq) {
    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  // Initialize event dedup tracker
  window.__fbPixelEvents = {}
  window.__fbPixelInitialized = true
}

function isPixelReady(): boolean {
  return typeof window !== 'undefined' && typeof window.fbq === 'function'
}

function hasEventFired(key: string): boolean {
  return !!(window.__fbPixelEvents && window.__fbPixelEvents[key])
}

function markEventFired(key: string) {
  if (!window.__fbPixelEvents) window.__fbPixelEvents = {}
  window.__fbPixelEvents[key] = true
}

/**
 * ViewContent - fires once when user sees the main landing/product section
 */
export function trackViewContent() {
  if (!isPixelReady()) return
  if (hasEventFired('ViewContent')) return

  window.fbq('track', 'ViewContent', {
    content_name: 'Cocina Productiva',
    content_category: 'Curso / Ebook',
  })

  markEventFired('ViewContent')
}

/**
 * AddToCart - fires once when user clicks specific purchase buttons
 */
export function trackAddToCart() {
  if (!isPixelReady()) return
  if (hasEventFired('AddToCart')) return

  window.fbq('track', 'AddToCart', {
    content_name: 'Cocina Productiva - Ebook + Bonos',
    content_type: 'product',
    value: 14999,
    currency: 'ARS',
  })

  markEventFired('AddToCart')
}
